<template>
  <div class="div_info">
    <div class="rfq">
      <!-- 插槽，将其余页面内容插入插槽内 -->
      <div class="headers"></div>
      <span class="time">{{ data }}</span>
      <div class="php">区域人房企可视化系统</div>
      <button :class="this.$route.path == '/rfq' ? 'a' : 'aa'" @click="rk">
        人口信息
      </button>
      <button :class="this.$route.path == '/rfq_qy' ? 'b' : 'bb'" @click="qy">
        企业信息
      </button>
      <button :class="this.$route.path == '/rfq_jz' ? 'c' : 'cc'" @click="jz">
        建筑信息
      </button>
      <button class="dd" @click="ht">后台管理</button>
    </div>
    <div class="rigth_r" @click="exting">
        <i class="el-icon-switch-button"></i>
        <p>退出</p>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: new Date(),
    };
  },
  mounted() {
    // 2021年12月2日 星期四 11:05
    let _this = this;
    this.timer = setInterval(() => {
      // _this.data = new Date().toLocaleString();
      let y = new Date().getFullYear() + "年";
      let m = new Date().getMonth() + 1 + "月";
      let d = new Date().getDate() + "日";
      let day = new Date().getDay();
      let dd = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      let days = dd[day];
      let h = new Date().getHours() + ":";
      let mi = new Date().getMinutes();
      if (mi < 10) {
        mi = "0" + mi;
      }
      _this.data = y + m + d + " " + days + " " + h + mi;
    });
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    exting() {
      this.$router.push("/infoData");
    },
    //点击事件
    ht() {
      this.$router.push("/Statistics/overviewStatistics?id=0");
    },
    qy() {
      this.$router.push("/rfq_qy");
    },
    rk() {
      this.$router.push("/rfq");
    },
    jz() {
      this.$router.push("/rfq_jz");
    },
  },
};
</script>

<style scoped lang="less">
.rigth_r{
  position: absolute;
  color: #fff;
  z-index: 1000;
  right: 1%;
  top: 2%;
  .el-icon-switch-button{
    position: absolute;
    right: 40px;
  }
}
.div_info {

  // padding-bottom: 20px;
  .rfq {
    color: #000;
    background-image: url(../assets/img/headers.png);
    background-repeat: no-repeat;
    background-size: 100vw 8vh;
    width: 100vw;
    height: 8vh;
    .time {
      float: left;
      color: rgba(255, 255, 255, 0.8);
      margin-top: 1.6vh;
      margin-left: 2vh;
    }
    .php {
      // text-align: center;
      position: absolute;
      left: 41.5vw;
      color: #fff;
      line-height: 7vh;
      font-size: 1.8vw;
      font-weight: 700;
    }
    button {
      position: absolute;
      border: 0;
      background-color: rgba(19, 158, 248, 0.7);
      width: 7vw;
      height: 3vh;
      border-radius: 4px;
      color: #fff;
      z-index: 99;
      margin-top: 1.6vh;
      left: 0.2vw;
    }
    .a {
      margin-left: 20vw;
      background-color: rgba(242, 186, 65, 0.7);
    }
    .aa {
      margin-left: 20vw;
      background-color: rgba(19, 158, 248, 0.7);
    }
    .b {
      margin-left: 28vw;
      background-color: rgba(242, 186, 65, 0.7);
    }
    .bb {
      margin-left: 28vw;
      background-color: rgba(19, 158, 248, 0.7);
    }
    .c {
      margin-left: 65vw;
      background-color: rgba(242, 186, 65, 0.7);
    }
    .cc {
      margin-left: 65vw;
      background-color: rgba(19, 158, 248, 0.7);
    }
    .d {
      margin-left: 73vw;
      background-color: rgba(242, 186, 65, 0.7);
    }
    .dd {
      margin-left: 73vw;
      background-color: rgba(19, 158, 248, 0.7);
    }
  }
}
</style>
